import { render, staticRenderFns } from "./Chapter4.vue?vue&type=template&id=06b352b1&"
import script from "./Chapter4.vue?vue&type=script&lang=js&"
export * from "./Chapter4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports